import {useState} from 'react'
import {TemplosListViewProvider} from './core/TemplosListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseTemplosProvider} from './core/QueryResponseTemplosProvider'
import {TemplosListHeader} from './components/header/TemplosListHeader'
import {TemplosListFilter} from './components/header/TemplosListFilter'
import {KTCard} from '../../../../../_metronic/helpers'
import {TemplosTable} from './table/TemplosTable'

const TemplosList = () => {
  const [filtersVisible, setFiltersVisible] = useState(false)

  let path = `/app/enroll/templo/00000/novo`

  return (
    <>
      <KTCard>
        <TemplosListHeader
          termo='templo'
          add_path={path}
          filtersVisible={filtersVisible}
          onToggleFilters={() => setFiltersVisible((v) => !v)}
        />
        <TemplosListFilter visible={filtersVisible} />
        <TemplosTable />
      </KTCard>
    </>
  )
}

const TemplosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseTemplosProvider>
      <TemplosListViewProvider>
        <TemplosList />
      </TemplosListViewProvider>
    </QueryResponseTemplosProvider>
  </QueryRequestProvider>
)

export {TemplosListWrapper}
